import React, { useState } from 'react';
import { Alert, Button, message, Modal } from 'antd';
import DraggerUpload from '../../../components/DraggerUpload';
import { API } from '../../../network/api';
import { downloadFile } from '../../../utils/helpers';

const fileVersion = (isPaddyBuyer) => (isPaddyBuyer ? 'V2' : 'V3');

const UploadModal = ({
  isOpen,
  setIsOpen,
  isPaddyBuyer = true,
  setFailedUrl,
  onSuccess,
  ...props
}) => {
  const [file, setFile] = useState();
  const [uploading, setUploading] = useState(false);

  const type = isPaddyBuyer ? 'PaddyBuyer' : 'FarmerGroupLeader';

  const downloadTemplate = async () => {
    const response = await API.get('/documents/download-template', {
      responseType: 'blob',
      params: {
        version: fileVersion(isPaddyBuyer),
        stakeHolderType: type,
      },
    });
    downloadFile(
      response.data,
      `Farmer_Stakeholders_${type}_Template_${fileVersion(isPaddyBuyer)}.csv`,
      'text/csv',
    );
  };

  const handleCancel = () => {
    if (!uploading) {
      setIsOpen(false);
      setFile(undefined);
    }
  };

  const handleOk = async () => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('stakeHolderType', type);
    formData.append('version', fileVersion(isPaddyBuyer));
    setUploading(true);
    setFailedUrl('');

    try {
      const response = await API.post('/documents/bulk-upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      const { successCount, failedCount } = { ...response.data.count };
      setFailedUrl('');
      localStorage.removeItem(`${type}_Failed_Data_URL`);

      if (failedCount > 0) {
        setFailedUrl(response.data.url);
        localStorage.setItem(`${type}_Failed_Data_URL`, response.data.url);
      }

      const messageConfig =
        successCount & failedCount
          ? {
              type: 'info',
              content: (
                <>
                  {successCount} Data Uploaded Successfully. {failedCount} data
                  failed to upload.{' '}
                  <a
                    href={response.data.url}
                    download={response.data?.url?.split('/')?.pop()}
                  >
                    Click here
                  </a>{' '}
                  to download the failed entries.
                </>
              ),
            }
          : successCount
            ? {
                type: 'success',
                content: `${successCount} Data Uploaded Successfully.`,
              }
            : {
                type: 'error',
                content: (
                  <>
                    {failedCount} Data failed to upload.{' '}
                    <a
                      href={response.data.url}
                      download={response.data?.url?.split('/')?.pop()}
                    >
                      Click here
                    </a>{' '}
                    to download the failed entries.
                  </>
                ),
              };
      message.open({
        ...messageConfig,
        duration: 30,
      });
      setIsOpen(false);
      if (onSuccess) onSuccess();
    } catch {
      message.error('There were some errors uploading the file');
    } finally {
      setFile(undefined);
      setUploading(false);
    }
  };

  const uploadProps = {
    onRemove: () => {
      setFile(undefined);
    },
    beforeUpload: (file) => {
      setFile(file);
      return false;
    },
  };

  return (
    <>
      <Modal
        title="Upload Stakeholders in Bulk"
        open={isOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        okButtonProps={{ loading: uploading }}
        cancelButtonProps={{ loading: uploading }}
        {...props}
      >
        <Alert
          message="Ensure you have a signed contract before adding a stakeholder. Only stakeholders who are confirmed may be added to the system."
          type="info"
          showIcon
          className="stakeholder-upload-alert"
          style={{
            border: 'none',
            margin: '0 0 16px',
          }}
        />
        <DraggerUpload
          accept=".csv"
          fileList={file ? [file] : []}
          loading={uploading}
          fileDescription=".CSV File"
          {...uploadProps}
        />
        <Button
          className="link-download"
          type="link"
          onClick={downloadTemplate}
        >
          Download CSV Template Here
        </Button>
      </Modal>
    </>
  );
};

export default UploadModal;
